<template>
  <div class="card-container">
    <template v-for="(item, index) in list">
      <router-link
        :key="index"
        class="card-slide"
        :to="`/teacher/${item.teacherId}`"
      >
        <c-card
          class="card-slide-item"
          :src="item.photoUrl"
          :title="item.nickname"
          :word="item.tag"
        />
      </router-link>
    </template>
  </div>
</template>

<script>
  import axios from 'axios';
  import CCard from 'components/card';

  export default {
    name: 'HomeTeacher',
    components: {
      CCard,
    },
    data() {
      return {
        list: [],
      };
    },
    created() {
      axios
        .get('https://api.zhuokao360.com/teacher/findAll?type=10')
        .then(({ data: { code, data } }) => {
          if (code === 200) {
            this.list = data || [];
          }
        });
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.card-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow-y: hidden;
  overflow-x: scroll;

  // 隐藏工具条
  &::-webkit-scrollbar {
    display: none;
  }

  .card-slide {
    + .card-slide {
      margin-left: 12px;
    }

    &-item {
      width: 200px;
      border-radius: 6px;
    }
  }
}
</style>
